import React from 'react';
import { inject, observer } from 'mobx-react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import type { AppStore } from '@stores/app/store';
import H5 from './layout/h5';
import styles from './index.module.scss';

interface PrizeManagementProps extends RouteComponentProps {
    app?: AppStore;
}

class PrizeManagement extends React.Component<PrizeManagementProps> {
    private restoreRootFontSize?: () => void;

    // PC 下复用 H5 页面时，维持 750px 设计稿对应的 rem 基准。
    private syncH5RemOnDesktop = () => {
        if (typeof window === 'undefined' || this.props.app?.platform !== 'pc') return;

        const root = document.documentElement;
        if (root.style.fontSize === '100px') return;
        const previousFontSize = root.style.fontSize;
        root.style.fontSize = '100px';
        this.restoreRootFontSize = () => {
            if (root.style.fontSize === '100px') {
                root.style.fontSize = previousFontSize;
            }
        };
    };

    componentDidMount() {
        this.syncH5RemOnDesktop();
    }

    componentDidUpdate() {
        this.syncH5RemOnDesktop();
    }

    componentWillUnmount() {
        this.restoreRootFontSize?.();
    }

    render() {
        const { app } = this.props;
        if (!app?.platform) {
            // 平台信息尚未初始化时显示加载状态
            return <div className={styles.loading}>加载中...</div>;
        }

        return (
            <div className={styles.h5Wrap}>
                <H5 desktopMode={app.platform === 'pc'} />
            </div>
        );
    }
}

export default inject('app')(observer(withRouter(PrizeManagement)));
